PegasusTemplate.PrettySelectsMixin = Em.Mixin.create({
  classNames: ['pretty-selects'],
});
